const steps = [
  {
    selector: '.tour-step-1',
    content: 'API Tasks. Here you\'ll find tasks that can send and retrieve information from a vendor\'s API. Just drag a vendor\'s icon onto the canvas and select which API call you\'d like to make.'
  },
  {
    selector: '.tour-step-2',
    content: 'Conditional. This task is for changing the flow of the worker based on results from previous tasks. The conditions you set will evaluate to "True" or "False" and you can configure the worker to handle each branch.'
  },
  {
    selector: '.tour-step-3',
    content: 'Comments. Drag this task onto the canvas to create a comment to provide more context to what your worker is doing.'
  },
  {
    selector: '.tour-step-4',
    content: 'Email. This task can be used to send an email at any point in your workflow. Use dynamic variables to make the emails more meaningful and format the text to make it more beautiful.'
  },
  {
    selector: '.tour-step-5',
    content: 'Webhooks. Think of these as notifications to external services. Some applications will happily receive a webhook and take action on it. You can format the information according to the needs of the service you\'re trying to connect to.'
  },
  {
    selector: '.tour-step-6',
    content: 'Templates. If you know what you\'d like to achieve but don\'t know where to start, this is where you\'ll find existing workers that you can modify to suit your needs.'
  }
]

export default steps;